import { Injectable } from '@angular/core';
import moment from 'moment';
import { Moment } from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { Organization } from "../../common/models/organization";
import { AnnualPlan } from "../../common/models/annual-plan";
import { Week } from "../../common/models/week";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({providedIn: 'root'})
export class WeekService {
    constructor(
        private _utils: UtilsProvider,
        private api: ApiBaseService,
        private currentUser: CurrentUser,
    ) {}

    public findPreviousByWeek(organization: Organization, plan: AnnualPlan, weekNumber: number): Observable<Week> {
        return this.api.call('get', `organizations/${organization.code}/plans/${plan.id}/prev-next-week?week=${weekNumber}&sort=-1`, {}, this.currentUser.getAccessToken()).pipe(map(
            (w) => Week.fromAPI(w)
        ));
        // return this.api.call('get',`organizations/${organization.id}/plans/${plan.id}/prev-next-week?week=${weekNumber}&sort=-1`).pipe(map(
        //     (w) => Week.fromAPI(w)
        // ));
    }

    public findNextByWeek(organization: Organization, plan: AnnualPlan, weekNumber: number): Observable<Week> {
        return this.api.call('get', `organizations/${organization.code}/plans/${plan.id}/prev-next-week?week=${weekNumber}&sort=1`, {}, this.currentUser.getAccessToken()).pipe(map(
            (w) => Week.fromAPI(w)
        ));
        // return this.api.call('get',`organizations/${organization.id}/plans/${plan.id}/prev-next-week?week=${weekNumber}&sort=1`).pipe(map(
        //     (w) => Week.fromAPI(w)
        // ));
    }

    public findRelatedWeek(date: Date, plan: AnnualPlan, weeks: Week[]): Week | null {
        if (!plan.startedAt) {
            return null;
        }

        const planMoment: Moment = moment(plan.startedAt);
        const dateMoment: Moment = moment(date);
        let weekCounter = 0;
        while (weekCounter < weeks.length) {
            if (planMoment.isSame(dateMoment, 'week')) {
                return weeks[weekCounter];
            }

            planMoment.add(1, 'week');
            weekCounter++;
        }

        return null;
    }
}
